import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useBrand } from "@/context/BrandContext";
import { ArrowLeft } from "@phosphor-icons/react";

const C = {
  bg: "#070B16", surface: "#0F1729", card: "#111a2e", green: "#10B981",
  orange: "#FF7A00", text: "#F8FAFC", sub: "#94A3B8", border: "rgba(255,255,255,0.10)",
};
const HEAD = { fontFamily: "'Outfit', sans-serif" };
const BODY = { fontFamily: "'Manrope', sans-serif" };

export const LegalShell = ({ title, updated, children, testid }) => {
  const brand = useBrand();
  useEffect(() => { document.title = `${title} · ${brand.brand_name || "iYeneh Connect"}`; }, [title, brand]);
  return (
    <div style={{ ...BODY, background: C.bg, color: C.text }} className="min-h-screen" data-testid={testid}>
      <header className="sticky top-0 z-20 border-b backdrop-blur"
        style={{ borderColor: C.border, background: "rgba(7,11,22,0.85)" }}>
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <span className="inline-flex items-center gap-2 align-middle"><img src="/icons/icon-512.png" alt="iYeneh Connect" className="h-8 w-8" /><span className="text-base font-bold tracking-tight text-foreground" style={{ fontFamily: "'Outfit', sans-serif" }}>iYeneh Connect</span></span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold"
            style={{ color: C.sub }} data-testid="legal-back-link">
            <ArrowLeft size={16} /> Back to home
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-10 sm:py-14">
        <p style={HEAD} className="text-sm font-bold uppercase tracking-[0.2em]" data-testid="legal-brand">
          {brand.brand_name || "iYeneh Connect"}
        </p>
        <h1 style={HEAD} className="mt-2 text-4xl font-extrabold sm:text-5xl" data-testid="legal-title">{title}</h1>
        <p className="mt-3 text-sm" style={{ color: C.sub }} data-testid="legal-updated">Last updated: {updated}</p>

        <div className="prose-legal mt-8 space-y-6 text-base leading-relaxed" style={{ color: "#CBD5E1" }}>
          {children}
        </div>

        <div className="mt-14 border-t pt-6 text-sm" style={{ borderColor: C.border, color: C.sub }}>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/privacy" className="hover:text-white" data-testid="legal-nav-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="legal-nav-terms">Terms of Service</Link>
            <Link to="/data-deletion" className="hover:text-white" data-testid="legal-nav-deletion">Data Deletion</Link>
          </div>
          <p className="mt-4">© {new Date().getFullYear()} {brand.legal_name || brand.brand_name || "Capital Defense Institute LLC"}. All rights reserved.</p>
          <p className="mt-1">{brand.brand_name || "iYeneh Connect"} is a service operated by {brand.legal_name || "Capital Defense Institute LLC"}.</p>
        </div>
      </main>
    </div>
  );
};

export const H2 = ({ children }) => (
  <h2 style={{ fontFamily: "'Outfit', sans-serif", color: "#F8FAFC" }} className="text-xl font-bold sm:text-2xl">{children}</h2>
);
export const P = ({ children }) => <p>{children}</p>;
export const UL = ({ children }) => <ul className="list-disc space-y-2 pl-6">{children}</ul>;
